import { AxiosResponse } from "axios";
import { apiNode } from "./api";
import { DefaultGetParamsProps } from "./types/interfaces";
import type {
	CreatePermissionSetDataProps,
	GetPermissionSetDataResponse,
	UpdatePermissionSetDataProps
} from "./types/permissionSet.interfaces";

const URL = "2/permission-sets/v2/permission-sets";

export const PermissionSetService = {
	async get({
		id
	}: DefaultGetParamsProps): Promise<GetPermissionSetDataResponse> {
		const response: AxiosResponse<GetPermissionSetDataResponse> =
			await apiNode.get(`${URL}/${id}/get-set`);
		return response.data;
	},
	async create({
		data
	}: {
		data: CreatePermissionSetDataProps
	}): Promise<any> {
		const response: AxiosResponse = await apiNode.post(`${URL}/create`, data);
		return response.data;
	},
	async update({
		data,
		id
	}: {
		data: UpdatePermissionSetDataProps
		id: string
	}): Promise<any> {
		const response: AxiosResponse = await apiNode.patch(
			`${URL}/${id}/update?confirmed=${data?.confirmed ?? false}`,
			data
		);
		return response?.data;
	},
	async delete({ id }: { id: string }): Promise<any> {
		const response: AxiosResponse = await apiNode.delete(
			`${URL}/${id}/delete`
		);
		return response?.data;
	}
};
